export default __webpack_public_path__ + "static/media/factionlessart.526c5f0f.webp";